var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "29px",
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / large / download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sprint-3_handover-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lg_Aktuelles_Aktuelles_\\xDCbersichtseite-Presse",
    transform: "translate(-443.000000, -1532.000000)",
    stroke: "#1A1919",
    strokeWidth: 1.81818182
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(80.000000, 1129.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(2.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(359.000000, 291.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 11.649036) rotate(-180.000000) translate(-16.000000, -11.649036) translate(7.000000, 2.740700)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 17.8166717,
    x2: 9,
    y2: 0.634853487,
    id: "Stroke-2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    points: "0 8.54135474 8.96867651 0.0589832015 9.03104129 0 18 8.48237154"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-8",
    points: "3.09386063 22.2298203 3.09386063 29.413765 28.9061394 29.413765 28.9061394 22.2298203"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDownload);
export default __webpack_public_path__ + "static/media/icons_download.014f16c9.svg";
export { ForwardRef as ReactComponent };